/**
 * animate toggles for header search form
 */
const setupSearchForms = () =>
{
	const container   = document.querySelector( '#header-search-container' );
	const toggle      = document.querySelector( '#search-toggle' );
	const toggleClass = 'expanded';

	if (toggle instanceof HTMLElement && container instanceof HTMLElement) {
		toggle.addEventListener( 'click', e =>
		{
			e.preventDefault();

			if (container.classList.contains( toggleClass )) {
				container.classList.remove( toggleClass );
			} else {
				container.classList.add( toggleClass );
			}
		} );
	}
};


/**
 *
 */
export default setupSearchForms;